<div class="my-0.5 px-8">
    <h1 class="
        mb-4
        text-4xl
        text-center
        font-extrabold
        leading-none tracking-tight
        text-gray-900
        md:text-5xl
        md:text-left
        lg:text-6xl
        dark:text-white"
    >
        Pottkinder Notfall-Bereitschaftsdienst
    </h1>
    <p class="italic mt-16">
        Die Handynummern dürfen nicht herausgegegen werden.
    </p>
</div>
